import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LsqListSource } from '@lsq-frontend/angular-shared/api-service';
import { FastTrackRouteQueryParams } from '@lsq-frontend/fasttrack-shared/app-constants';
import {
    ACCOUNT_SUPPLIER_DETAILS,
    atlas,
    BUYER_ACCOUNT_INVOICE_DETAIL,
    BUYER_SUPPLIER_DETAILS
} from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import {
    InvoiceDetailsItemResponse,
    InvoiceFundingStatus2
} from '@lsq-frontend/remote-services/financing-graphql';
import { Color, getDynamicRouterLink, StatusColor } from '@lsq-frontend/common-ui';
import { ClaimService, getRouterLinkById, ResponsiveService } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
import {
    InvoiceFundingStatusDisplay,
    InvoiceFundingStatusDotEnum
} from '../../../supply-chain-direct.models';
import { InvoiceFundingStatusModifications } from '../invoice-detail-page.component';
@Component({
    selector: 'invoice-detail-card',
    template: ` <div card-body class="card-contents scf-invoice-detail-card">
        <div class="row" *ngIf="invoiceDetailsDataSource">
            <div class="summary-table-card-wrapper col-12">
                <card
                    i18n-headerTitle
                    headerTitle="Invoice Details"
                    id="invoices-table-card"
                    *ngIf="!(responsiveService.mdBelow | async)"
                >
                    <div card-body class="invoice-table">
                        <lsq-data-table
                            *ngIf="invoiceDetailsDataSource"
                            [hasHeader]="true"
                            [dataSource]="invoiceDetailsDataSource"
                            [isPaginated]="false"
                            [layoutFixed]="true"
                        >
                            <lsq-column
                                [column]="{
                                    header: statusI18n,
                                    key: 'status',
                                    width: '15%',
                                    sortable: false
                                }"
                            >
                                <ng-template [custom-cell] let-row="row">
                                    <status-pill
                                        [status]="getInvoiceStatus(row)"
                                        [color]="statusColor[row.status] || processingColor"
                                        [displayValueMap]="invoiceFundingStatusDisplay"
                                    >
                                    </status-pill>
                                </ng-template>
                            </lsq-column>
                            <lsq-column
                                [column]="{
                                    header: supplierI18n,
                                    key: 'sellerName',
                                    truncateTextCss: true,
                                    sortable: false,
                                    width: '25%'
                                }"
                            >
                                <ng-template [custom-cell] let-row="row">
                                    <div class="text-truncate" [style.maxWidth]="'35rem'">
                                        <a
                                            class="p not-bold supplier-name"
                                            (click)="goSupplierDetails(row.sellerKey)"
                                            queryParamsHandling="preserve"
                                        >
                                            {{ row.sellerName }}
                                        </a>
                                    </div>
                                </ng-template>
                            </lsq-column>
                            <lsq-date-column
                                [isShortDate]="true"
                                [alignRight]="true"
                                [column]="{
                                    header: invoiceDateI18n,
                                    key: 'invoiceDate',
                                    width: '20%',
                                    sortable: false
                                }"
                            >
                            </lsq-date-column>
                            <lsq-currency-column
                                [column]="{
                                    header: invoiceAmountI18n,
                                    key: 'amount',
                                    width: '20%',
                                    sortable: false
                                }"
                            >
                            </lsq-currency-column>
                            <lsq-date-column
                                [isShortDate]="true"
                                [alignRight]="true"
                                [column]="{
                                    header: invoiceDueDateI18n,
                                    key: 'dueDate',
                                    width: '20%',
                                    sortable: false
                                }"
                            >
                            </lsq-date-column>
                        </lsq-data-table>
                    </div>
                </card>
                <div *ngIf="responsiveService.mdBelow | async">
                    <h2 class="mobile-section-header"></h2>
                    <lsq-data-table-mobile
                        [dataSource]="invoiceDetailsDataSource"
                        [isPaginated]="false"
                    >
                        <ng-template #mobileCardHeader let-row="row">
                            <div class="mtc-header-content">
                                <div class="invoice-list-mobile-card-header">
                                    <div class="mtc-header-content-left">
                                        <div class="mtc-header-title">
                                            {{ row.amount | currencyDash }}
                                        </div>
                                    </div>
                                    <div class="mtc-header-content-right">
                                        <status-pill
                                            [status]="row.fundingStatus"
                                            [color]="
                                                statusColor[row.fundingStatus] || processingColor
                                            "
                                            [displayValueMap]="invoiceFundingStatusDisplay"
                                        >
                                        </status-pill>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #mobileCardColumns let-row="row">
                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ supplierI18n }}
                                </div>
                                <div class="card-item-value">
                                    <a
                                        class="p not-bold supplier-name"
                                        (click)="goSupplierDetails(row.sellerKey)"
                                        queryParamsHandling="preserve"
                                    >
                                        {{ row.sellerName }}
                                    </a>
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ invoiceDateI18n }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.invoiceDate | lsqDate: 'shortDate' }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ invoiceDueDateI18n }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.dueDate | lsqDate: 'shortDate' }}
                                </div>
                            </div>
                        </ng-template>
                    </lsq-data-table-mobile>
                </div>
            </div>
        </div>
    </div>`,
    styleUrls: ['./invoice-detail-card.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BuyerAccountInvoiceDetailCardComponent {
    @Input() public invoiceDetailsDataSource!: LsqListSource<InvoiceDetailsItemResponse>;
    public readonly statusColor = StatusColor;
    public readonly processingColor = Color.Yellow;
    public readonly invoiceFundingStatus = InvoiceFundingStatus2;
    public readonly invoiceFundingStatusDotEnum = InvoiceFundingStatusDotEnum;
    public readonly invoiceFundingStatusModifications = InvoiceFundingStatusModifications;

    public readonly paymentTotalI18n = this._i18n('Payment Total');
    public readonly statusI18n = this._i18n('Status');
    public readonly positiveInvoicesI18n = this._i18n('Positive Invoices');
    public readonly creditAmountI18n = this._i18n('Credit Amount');
    public readonly revokeHeaderI18n = this._i18n({ value: 'Revoke' });
    public readonly revokeModalTitleI18n = this._i18n({ value: 'Revoke Invoice' });
    public readonly revokeGroupModalTitleI18n = this._i18n({ value: 'Revoke Invoices' });

    public readonly supplierI18n = this._i18n({
        value: 'Supplier',
        meaning: `The supplier for the invoice`,
        description: 'Table column header'
    });
    public readonly invoiceNumberI18n = this._i18n({
        value: 'Invoice Number',
        meaning: `Invoice number`,
        description: 'Table column header'
    });
    public readonly invoiceDateI18n = this._i18n({
        value: 'Invoice Date',
        meaning: `Invoice date`,
        description: 'Table column header'
    });

    public readonly invoiceDueDateI18n = this._i18n({
        value: 'Due Date',
        meaning: `Due date`,
        description: 'Table column header'
    });

    public readonly dueInI18n = this._i18n({
        value: 'Due In',
        meaning: `Days until the invoice is due to be paid by the buyer`,
        description: 'Table column header'
    });
    public readonly invoiceAmountI18n = this._i18n({
        value: 'Invoice Amount',
        meaning: `The money value of the invoice`,
        description: 'Table column header'
    });
    public readonly invoiceStatusI18n = this._i18n({
        value: 'Status',
        meaning: `The eligibility status of the invoice`,
        description: 'Table column header'
    });

    public isFinancingAccountPortalUser = false;

    constructor(
        private _i18n: I18n,
        public invoiceFundingStatusDisplay: InvoiceFundingStatusDisplay,
        private _claimService: ClaimService,
        public responsiveService: ResponsiveService,
        private _router: Router
    ) {
        this.isFinancingAccountPortalUser = this._claimService.isOnSync(
            DashboardClaim.FinancingAccountPortal
        );
    }

    public getInvoiceStatus(row: InvoiceDetailsItemResponse): string {
        if (row.finalApprovedAmount!!.cents!! < 0) {
            return this.invoiceFundingStatusModifications.CREDIT_MEMO;
        } else if (row.fundingStatus == this.invoiceFundingStatus.SCHEDULED) {
            return this.invoiceFundingStatus.UNFUNDED;
        } else {
            return InvoiceFundingStatus2[row.status!];
        }
    }

    public goSupplierDetails(sellerKey: string) {
        this._router.navigateByUrl(
            this._router.createUrlTree(
                getDynamicRouterLink(
                    getRouterLinkById(
                        atlas,
                        this.isFinancingAccountPortalUser
                            ? ACCOUNT_SUPPLIER_DETAILS
                            : BUYER_SUPPLIER_DETAILS,
                        {
                            noStandaloneLeadingSlash: true
                        }
                    ),
                    { sellerKey }
                ),
                {
                    queryParams: {
                        [FastTrackRouteQueryParams.PreviousRouteId]: BUYER_ACCOUNT_INVOICE_DETAIL
                    }
                }
            )
        );
    }
}
